import React, { FC, Fragment } from 'react';
import { useDevice } from '../../constants/device/device';
import { ReactComponent as IconArrowRight } from '../../icons/arrow-right.svg';
import { IIconArrowStep } from '../iconArrowSteps/iconArrowSteps';
import { ArrowWrapper, StepCircle, StepText, StepWrapper, Wrapper } from './iconArrowSteps.styles';

interface Props {
	steps: IIconArrowStep[];
}

const IconArrowSteps: FC<Props> = ({ steps }) => {
	const { mobileDevice, smallDevice } = useDevice();
	if (mobileDevice) {
		return null;
	}
	return (
		<Wrapper>
			{steps.map((step, index) => {
				const Icon = step.iconComponent;
				return (
					<Fragment key={index}>
						<StepWrapper primary={step.primary} secondary={step.secondary}>
							<StepCircle>
								<Icon />
							</StepCircle>
							{!smallDevice && <StepText>{step.text}</StepText>}
						</StepWrapper>
						{index < steps.length - 1 && (
							<ArrowWrapper primary={step.primary} secondary={step.secondary}>
								<IconArrowRight />
							</ArrowWrapper>
						)}
					</Fragment>
				);
			})}
		</Wrapper>
	);
};

export default IconArrowSteps;
